export class LookupTypeKeys {
  static readonly PREBOARDING_STATUS = 1;
  static readonly CURRENT_EMPLOYEMENT_STATUS = 17;
  static readonly ONBOARDING_TYPES = 26;
  static readonly EMPLOYEE_CATEGORY_TYPES = 11;
  static readonly TYPE_OF_EMPLOYMENT = 190;
  static readonly OFFICE_LOCATION_COUNTRY = 27;
  static readonly WORKL_LOCATION_DURING_TRIP = 261;
  static readonly OFFICE_LOCATION = 9;
  // static readonly OFFICE_LEGAL_ENTITY = 10;
  static readonly SERVICE_LINE = 4;
  static readonly SUB_SERVICE_LINE = 5;
  // static readonly SUB_SUB_SERVICE_LINE = 6;
  // static readonly INDUSTRY_OR_SECTOR = 7;
  // static readonly SMU = 8;
  static readonly RANK = 13;
  static readonly GRADE = 14;
  static readonly PREVIOUS_EY_EXPERIENCE = 15;
  static readonly GENDER = 2;
  static readonly MODE_OF_STUDY = 259;
  static readonly NATIONALITY = 3;
  static readonly MARITAL_STATUS = 23;
  static readonly NO_OF_DEPENDENTS = 24;
  static readonly CONTRACT_TYPES = 28;
  static readonly HIRE_TYPE = 12;
  static readonly RECRUITMENT_DOCUMENT_TYPES = 29;
  static readonly YESNO_TYPES = 30;
   static readonly ACCOMMODATION_TYPES = 266;
  static readonly REQUESTED_SERVICES = 262;
  static readonly YESNONA_TYPES = 33;
  static readonly YESNOMAYBE_TYPES = 34;
  static readonly PREBOARDING_DOCUMENT_TYPES = 31;
  static readonly START_DATE_STATUS = 16;
  static readonly TRANSFER_TYPES = 19;
  static readonly TRANSFER_SCENARIO = 20;
  static readonly IMMIGRATION_CASE_TYPE = 21;
  static readonly CURRENT_VISA_STATUS = 18;
  static readonly HOTEL_AND_FLIGHT_BOOKING = 22;
  static readonly RELOCATION_BENEFITS = 25;
  static readonly BUSINESS_UNIT = 35;
  static readonly OPERATION_UNIT = 36;
  static readonly MANAGEMENT_UNIT = 37;
  static readonly ENTRY_TYPE = 39;
  static readonly VISA_DURATION = 263;
  static readonly PURPOSE_OF_VISIT = 265;
  static readonly IMMIGRATION_DOCUMENT_TYPES = 40;
  static readonly IMMIGRATION_STATUSES = 41;
  static readonly RESIDENCY_STATUS = 42;
  static readonly EY_VISA_LC_STATUS = 43;
  static readonly BUSINESS_VISA_DURATION_OF_STAY = 44;
  static readonly EMPLOYEE_CURRENT_LOCATION_COUNTRY = 3; // NATIONALITY'S ID
  static readonly CANCELLATION_REASON = 45;
  static readonly PASSPORT_TYPES = 46;
  static readonly VISA_TYPE = 38;
  static readonly ENROLLMENT_TYPE = 60;
  static readonly WORK_TIMING = 61;
  static readonly LANGUAGES = 62;
  static readonly WORK_WEEK = 63;
  static readonly JOB_BENEFITS = 64;
  static readonly RELIGION = 65;
  static readonly SECT = 66;
  static readonly HIGHER_LOWER = 67;
  static readonly MOL_CONTRACT = 68;
  static readonly SHORT_TERM_VISA = 100;
  //static readonly ISSUING_COUNTRY = 80;
  //static readonly GOVT_AUTHORITY_ATTESTATION = 81;
  static readonly PERMIT_TYPE = 82;
  static readonly BLOOD_GROUP = 83;
  static readonly TYPE_OF_SUPPORT = 84;
  static readonly TYPE_OF_MODIFCATION = 85;
  static readonly RELATIONSHIPS = 101;
  static readonly TYPE_OF_REQUEST = 102;
  static readonly CPR_CASE_TYPE = 112;
  static readonly REASON_FOR_VISIT = 113;  
  static readonly BUSINESS_VISA_DURATION_OF_STAY_QAT = 116;
  static readonly MISSION_VISA_CATEGORY = 117;
  static readonly EXIT_STATUSES = 130;
  static readonly EXIT_TYPES = 131;
  static readonly EXIT_SUBTYPES = 134;
  static readonly ACADEMIC_QUALIFICATION = 135;
  static readonly CATEGORY_OF_JOBOFFER = 136;
  static readonly REASON_FOR_VISIT_UAE_BV = 137;
  static readonly REASON_FOR_RENEWAL = 138;
  static readonly VACCINATION_STATUS = 151;
  static readonly VACCINE_TYPE = 152;

  static readonly LETTER_TO_BE_USED = 148;
  static readonly REASON_OF_SEPERATION = 149;
  static readonly APPLICATION_OF_NOTICE = 150;
  static readonly TRAVEL_TYPE = 153;
  static readonly NOMINATION = 155;
  static readonly RP_CURRENT_EMPLOYEMENT_STATUS = 156;
  static readonly LABOUR_CARD_CANCELLATION_TYPE = 157;
  static readonly TERMINATION_TYPE = 159;
  static readonly TRAVEL_TIME_PREFERNCE = 161;
  static readonly EOSB = 165;
  static readonly MANAGE_LEAVE_BALANCE = 166;
  static readonly SHORT_TRAVEL_TYPE = 168;
  static readonly No_Of_Extension_Times = 170;
  static readonly VACCINATION_STATUS_IMM = 171;
  static readonly TypeOfDocRequested = 176;
  static readonly CITIZENSHIP = 180;
  static readonly CHOICE_OF_INSURANCE = 182;
  static readonly DocumentSupportType = 184;
  static readonly REASON_FOR_LOWER_JOB_TITLE = 185;
  static readonly WORK_PERMIT_TYPE = 186;
  static readonly NATIONALITY_TYPE = 187;
  static readonly DOCUMENT_ATTESTAION = 193;
  static readonly VENDOR_NAME = 194;
  static readonly SERVICE_COMPLETED = 195;
  static readonly CPR_TYPE = 198;
  static readonly INVOICE_CURRENCY = 200;
  static readonly COST_REFERENCE = 201;
  static readonly REASON_FOR_VISIT_PAK_BV = 205;
  static readonly OFFICETOVISIT_PAK_BV = 206;
  static readonly MULTI_EXIT_QUESTIONS = 208;
  static readonly TYPE_OF_VISA = 210;
   static readonly TYPE_OF_VISA_Required = 264;
  static readonly YES_NO_INITATED = 215;
  static readonly BIGFOURCOMPANIES = 216;
  static readonly REASON_FOR_VISIT_JOR = 220;
  static readonly CW_STATUSES = 225;
  static readonly FLIGHT_BOOKING_STATUS_EMP = 235;
  static readonly FLIGHT_BOOKING_STATUS_DEP = 236;
  static readonly DOCUMENT_TYPES = 47;
  static readonly DOCUMENT_NAMES = 48;
  static readonly HOTEL_AND_FLIGHT_BOOKING_STATUS = 237;
  static readonly PO_INITIATION_TYPE = 238;
  static readonly PO_STATUS = 239;
  static readonly PAYMENT_STATUS = 240;

  static readonly DEPENDENTS_VISA_CANCELLATION_STATUS =241;
  static readonly GDA_PROCESS_REQUIREMENT = 242;
  static readonly IT_CLEARANCE = 243;
  static readonly HOME_COUNTRY_VISA_CANCELLATION_STATUS = 244;
  static readonly EXIT_FORMALITIES_STATUS = 245;
  static readonly GDA_PROCESS_STATUS = 246;

  static readonly EXCEPTION_STATUS = 250;
  static readonly VISA_JOB_TITLE_CHANGE_STATUS = 251;
  static readonly PJ_DOCUMENT_COLLECTED = 252;
  
  static readonly EDUCATION_DOCUMENT_PROCUREMENT_ATTESTATION = 255;
  static readonly EDUCATION_DOCUMENT_ATTESTATION = 256;
  static readonly  EXCEPTIONAL_APPROVAL_STATUS = 257;
  static readonly CORPORATE_DOCUMENT_STATUS = 258;
  
  static readonly PROCESSING_TEAM = 268;
  static readonly PROCESSING_BY = 269;
  static readonly REQUIRED_ATTESTATION = 270;

  static readonly WORK_LOCATION = 272;
  static readonly DURATION = 273;
  static readonly PRIME_TYPE = 274;
  static readonly CONTRACT_STATUS = 275;
  static readonly IT_Assets = 276;
  static readonly ASSET_COURIER = 277;
  static readonly ACCESS_CARD = 278;
  
}

